export default __webpack_public_path__ + "atomic/_patterns/03-organisms/seed-variety/_seed-variety--full.twig";